<div class="flex flex-col w-full h-full bg-white border-r border-neutral-50">
  <div class="flex flex-col grow gap-0.5 w-full px-2 py-6 overflow-y-auto">
    @if (heading()) {
      <div
        class="px-2 pt-1 pb-2 text-[11px] leading-4 font-semibold uppercase tracking-[0.08em] text-neutral-400"
        data-testid="nav-menu-heading"
      >
        {{ heading() }}
      </div>
    }
    @for (item of items(); track item.name) {
      @if (item.visible) {
        <flx-nav-menu-item
          [icon]="item.icon"
          [useCustomIcon]="item.useCustomIcon"
          [name]="item.name"
          [route]="item.route"
          [children]="item.children"
        />
      }
    }
  </div>
</div>
